import React, { useEffect, useState } from 'react';
import './FounderPage.css';
import { getFounder } from '../../services/contentService';

const FounderPage = () => {
  const [founderData, setFounderData] = useState(null);

  useEffect(() => {
    getFounder().then(setFounderData);
  }, []);

  return (
    <div className="founder-page">
      <div className="page-header">
        <h1 className="slide-left">THE FACE BEHIND THE GLAM</h1>
      </div>

      {founderData && (
        <div className="founder-content">
          <div className="founder-card slide-up">
            <img src={founderData.Image} alt="Founder" className="founder-img" />
            <h2>{founderData.Name}</h2>
            <h4>{founderData.Subheading}</h4>
          </div>

          <div className="founder-bio slide-up">
            <p>{founderData.Paragraph}</p>
          </div>

          {/* <div className="founder-social slide-up">
            <a href={founderData.Instagram} target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href={founderData.LinkedIn} target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>
            <a href={founderData.Whatsapp} target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default FounderPage;
